import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { React, useState } from "react";
import Logo from "../asset/images/logo2.png";
import { Link } from "react-router-dom";

export const Authheader = () => {
  return (
    <>
    
    <header className="authheader">
     
   

      <nav className="navbar bg-dark navbar-static-top navbar-expand-lg header-sticky pt-0">
        <div className="container-fluid d-flex justify-content-center">
          <button
            type="button"
            className="navbar-toggler"
            data-bs-toggle="collapse"
            data-bs-target=".navbar-collapse"
          >
            <i className="fas fa-align-left" />
          </button>
          <Link to="/" className="navbar-brand">
            {/* <h1 className="text-light">Flex-Rental</h1> */}
            <img className="img-fluid" src={Logo} alt="logo" />
          </Link>

        

        </div>
      </nav>
    </header>
  </>
  )
}

export default Authheader;
